import { Typography, TypographyProps } from '@material-ui/core'
import { RequiredSign } from 'pages/content/components/jobs/components/atoms'
import { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'

export interface IFormLabelProps extends TypographyProps {
  required?: boolean
}

const StyledLabel = styled(Typography)`
  && {
    color: ${props => props.theme.colors.accent1};
    font-weight: 700;
  }
`

export const FormLabel = ({ children, required, ...rest }: PropsWithChildren<IFormLabelProps>) => {
  return (
    <StyledLabel variant="body2" {...rest}>
      {children}
      <RequiredSign visible={required} />
    </StyledLabel>
  )
}
